import { readonly, ref } from 'vue'

const url = ref<string | null>(null)

export const certificateViewerUrl = readonly(url)

export function openCertificateViewer(source: string, event?: MouseEvent) {
  if (
    event &&
    (event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey)
  )
    return

  event?.preventDefault()
  if (event?.currentTarget instanceof HTMLElement)
    event.currentTarget.focus({ preventScroll: true })
  url.value = source
}

export function closeCertificateViewer() {
  url.value = null
}

export function certificateFilename(source: string) {
  try {
    const name = decodeURIComponent(
      new URL(source).pathname.split('/').pop() ?? ''
    ).replace(/[\\/:*?"<>|]/g, '_')
    if (name) return /\.pdf$/i.test(name) ? name : `${name}.pdf`
  } catch {
    return 'certificate.pdf'
  }
  return 'certificate.pdf'
}
